import {isEmpty} from 'lodash';
import {Component, Input} from '@angular/core';

@Component({
    selector: 'tfl-bo-profile-whitelablel',
    template: `
        <span *ngIf="!isBlankWhitelabel()" class="label label-whitelabel label-danger">
            WL: {{ whitelabel }}
        </span>
    `
})
export class WhitelabelBadgeComponent {

    @Input('whitelabel') whitelabel: string;

    isBlankWhitelabel(): boolean {
        return isEmpty(this.whitelabel);
    }
}


// WEBPACK FOOTER //
// ./~/angular2-template-loader!./~/angular-router-loader/src!./src/dashboard/app/modules/customers/shared/components/whitelabel.badge.component.ts